import { render, staticRenderFns } from "./nav-header.vue?vue&type=template&id=64b675bc&scoped=true&"
import script from "./nav-header.vue?vue&type=script&lang=js&"
export * from "./nav-header.vue?vue&type=script&lang=js&"
import style0 from "./nav-header.vue?vue&type=style&index=0&id=64b675bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b675bc",
  null
  
)

export default component.exports